import { createContractRequest } from './helper';
export const postRecommendedOffers = createContractRequest({
    source: 'data',
    route: '/contract/offers/recommended',
    method: 'post',
});
